// extracted by mini-css-extract-plugin
export default {"button":"button_button__rCjJV","text":"button_text__-QTbb"};